"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var HttpService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
const tsyringe_1 = require("tsyringe");
const axios_1 = __importDefault(require("axios"));
const memory_cache_1 = __importDefault(require("memory-cache"));
const required_1 = require("../../../../helpers/required/required");
let HttpService = HttpService_1 = class HttpService {
    constructor() {
        this.httpFetch = (url, config) => axios_1.default(url, config).then(result => result.data);
    }
    static get defaultConfig() {
        return {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        };
    }
    fetchWithCache(url, config = Object.assign({}, HttpService_1.defaultConfig)) {
        required_1.requiredDefined(url, 'url should be defined');
        const request = memory_cache_1.default.get(url);
        if (!request) {
            const cacheTimeout = 30 * 1000;
            memory_cache_1.default.put(url, this.fetch(url, config), cacheTimeout)
                .catch(e => {
                memory_cache_1.default.del(url);
                return Promise.reject(e);
            });
        }
        return memory_cache_1.default.get(url);
    }
    /**
       * HTTP call
       * Default configuration of headers is method GET and content-type: application/json
       * @param url
       * @param config
       * @return Promise{any}
       */
    fetch(url, config = Object.assign({}, HttpService_1.defaultConfig)) {
        return __awaiter(this, void 0, void 0, function* () {
            if (config.body) {
                config.data = config.body;
            }
            try {
                return this.httpFetch(url, config);
            }
            catch (e) {
                console.warn('Error on fetch', url, config);
                return Promise.reject(e);
            }
        });
    }
};
HttpService = HttpService_1 = __decorate([
    tsyringe_1.scoped(tsyringe_1.Lifecycle.ContainerScoped)
], HttpService);
exports.HttpService = HttpService;
//# sourceMappingURL=httpService.js.map